[
  {
    "dia": "14M",
    "mupi": 2,
    "hora": "10h25min",
    "numero": 5,
    "titulo": "Tradução e Adaptação cultural do questionário “Oral Cancer Pain Questionnaire” – UCSF",
    "autor": "Cristiana Rodrigues"
  },
  {
    "dia": "14M",
    "mupi": 2,
    "hora": "10h32min",
    "numero": 6,
    "titulo": "Avaliação do Biomarcador Salivar Cortisol em Doentes com Disfunção Temporomandibular",
    "autor": "Carla Cardoso"
  },
  {
    "dia": "14M",
    "mupi": 2,
    "hora": "10h39min",
    "numero": 7,
    "titulo": "Eficácia da Acupuntura em casos de Disfunção Temporomandibular Crónica: protocolo de estudo piloto",
    "autor": "Mariana Frade"
  },
  {
    "dia": "14M",
    "mupi": 2,
    "hora": "10h46min",
    "numero": 8,
    "titulo": "O impacto dos autocuidados em ambulatório na Disfunção Temporomandibular – Protocolo clínico",
    "autor": "Beatriz O. Castro"
  },
  {
    "dia": "14M",
    "mupi": 2,
    "hora": "10h53min",
    "numero": 40,
    "titulo": "Avaliação do Conhecimento e Consciencialização dos Estudantes de Medicina Dentária sobre a Prescrição de Antibióticos em Endodontia",
    "autor": "Francisco Faria"
  }
]